import { AGE_THRESHOLDS } from '@internal/utils-common';
import {
  StatusAborted,
  StatusError,
  StatusOK,
  StatusWarning,
} from '@backstage/core-components';

export const scoreRules = {
  red: {
    text: 'Need Attention',
    rule: (changedSince: number) => changedSince > AGE_THRESHOLDS.m12_365,
    info: 'Secrets changed more than 1 year ago.',
    icon: StatusError,
  },
  orange: {
    text: 'Advisory',
    rule: (changedSince: number) =>
      changedSince > AGE_THRESHOLDS.m6_181 &&
      changedSince <= AGE_THRESHOLDS.m12_365,
    info: 'Secrets changed more than 6 months and less than 1 year ago.',
    icon: StatusWarning,
  },
  green: {
    text: 'Healthy',
    rule: (changedSince: number) => changedSince <= AGE_THRESHOLDS.m6_181,
    info: 'Secrets changed less than 6 months.',
    icon: StatusOK,
  },
  orphaned: {
    text: 'Orphaned',
    rule: (team: string | undefined) => !team || team === 'orphaned',
    info: 'Secrets is not assigned to any team.',
    icon: StatusAborted,
  },
};
